import {
  Component,
  OnInit
} from '@angular/core';

import {
  ActivatedRoute,
  Router
} from '@angular/router';
import { XQualification } from 'src/app/core/XQualification';
import { CourseService } from 'src/app/services/course/course.service';
import { FileUploadService } from 'src/app/services/file-upload/file-upload.service';
import { OrderService } from 'src/app/services/order/order.service';



interface SelectedTrainingCourse {
  type: 'UOC' | 'VOC' | 'COA' | 'COURSE';
  code: string;
  name: string;
}


@Component({
  selector:
    'app-x-paid-registration',

  templateUrl:
    './x-paid-registration.component.html',

  styleUrl:
    './x-paid-registration.component.scss'
})
export class XPaidRegistrationComponent
  implements OnInit {
  // ============================================================
  // ORDER
  // ============================================================

  orderId: number = 0;

  courseTitle: string = '';

  // Courses shown in the Selected Training section.
  // Kept outside participant so this display-only data is not
  // added to the registration JSON body.
  selectedTrainingCourses:
    SelectedTrainingCourse[] = [];

  isLoading: boolean = false;

  isSubmitting: boolean = false;

  loadError: string = '';

  submitError: string = '';

  submitSuccess: boolean = false;



  // ============================================================
  // REGISTRATION BODY
  // ============================================================

  participant: any = {

    // ----------------------------------------------------------
    // ORDER DETAILS
    // ----------------------------------------------------------

    orderId: 0,

    courseTitle: '',


    // ----------------------------------------------------------
    // BASIC DETAILS
    // ----------------------------------------------------------

    firstName: '',

    lastName: '',

    emailAddress: '',

    mobileNumber: '',

    address: '',

    dateOfBirth: '',


    // ----------------------------------------------------------
    // EDUCATION
    // ----------------------------------------------------------

    qualificationId: null,

    qualificationName: '',

    usi: '',


    // ----------------------------------------------------------
    // QUALIFICATION CERTIFICATES
    // ----------------------------------------------------------

    qualificationCertificates: [],

    certificateUploadError: '',


    // ----------------------------------------------------------
    // IDENTITY DOCUMENTS
    // ----------------------------------------------------------

    idDocuments: [
      {
        idType: '',
        fileName: '',
        fileUrl: '',
        uploadError: '',
        isUploading: false
      }
    ],


    // ----------------------------------------------------------
    // SUBMITTED DATE
    // ----------------------------------------------------------

    submittedDate: new Date().toLocaleDateString('en-CA'),


    // ----------------------------------------------------------
    // DECLARATION
    // ----------------------------------------------------------

    declarationTrueCorrect: false,

    declarationAdditionalEvidence: false,

    declarationPracticalCompetency: false,

    applicantName: '',

    signature: '',

    declarationDate: new Date().toLocaleDateString('en-CA')
  };
  qualificationList:
    XQualification[] =
    [];
  identityTypesList: any[] = [];


  constructor(
    private route:
      ActivatedRoute,

    private shortCourseService:
      OrderService,

    private uploadService:
      FileUploadService,
    private router: Router,
    private courseService: CourseService
  ) { }


  // ============================================================
  // INIT
  // ============================================================

  ngOnInit(): void {

    this.readOrderIdFromUrl();

    // Load qualification dropdown
    this.loadQualificationList();
    this.getIdentityTypes();

  }

  getIdentityTypes(): void {

    this.courseService
      .GetIdentityTypesList()
      .subscribe({
        next: (response: any) => {

          this.identityTypesList =
            response || [];

        },
        error: (error: any) => {

          console.error(
            'Error loading identity types',
            error
          );

          this.identityTypesList = [];
        }
      });
  }
  // ============================================================
  // LOAD QUALIFICATION LIST
  // ============================================================

  loadQualificationList(): void {

    this.courseService
      .getXQualificationList()
      .subscribe({

        next: (
          response: any[]
        ) => {

          const source =
            response || [];


          this.qualificationList =
            source.map(
              (
                qualification: any
              ) => {

                return {

                  id:
                    Number(
                      qualification?.id
                      ??
                      qualification?.Id
                      ??
                      0
                    ),

                  qualificationName:
                    (
                      qualification?.qualificationName
                      ??
                      qualification?.QualificationName
                      ??
                      ''
                    )
                      .toString()
                      .trim(),

                  qualificationType:
                    (
                      qualification?.qualificationType
                      ??
                      qualification?.QualificationType
                      ??
                      ''
                    )
                      .toString()
                      .trim(),

                  isActive:
                    Boolean(
                      qualification?.isActive
                      ??
                      qualification?.IsActive
                      ??
                      false
                    )
                };

              }
            )
              .filter(
                qualification =>
                  qualification.id > 0
              );
        },


        error: (
          error
        ) => {

          console.error(
            'Unable to load qualification list:',
            error
          );


          this.qualificationList =
            [];
        }

      });
  }
  // ============================================================
  // EDUCATION QUALIFICATION CHANGE
  // ============================================================

  onEducationQualificationChange(
    qualificationId: number | null
  ): void {

    if (
      qualificationId === null ||
      qualificationId === undefined
    ) {
      this.participant.qualificationId = null;
      this.participant.qualificationName = '';
      return;
    }

    const selectedQualification =
      this.qualificationList.find(
        qualification =>
          Number(qualification.id) ===
          Number(qualificationId)
      );

    this.participant.qualificationId =
      selectedQualification?.id ?? null;

    this.participant.qualificationName =
      selectedQualification?.qualificationName || '';
  }


  // ============================================================
  // READ ORDER ID
  // ============================================================

  private readOrderIdFromUrl(): void {

    const enquiryId =
      this.route.snapshot.queryParamMap.get(
        'orderId'
      );


    if (!enquiryId) {

      this.loadError =
        'Invalid registration link.';

      return;

    }


    const orderId =
      Number(enquiryId);


    if (
      !Number.isInteger(orderId) ||
      orderId <= 0
    ) {

      this.loadError =
        'Invalid registration link.';

      return;

    }


    this.orderId =
      orderId;


    this.loadRegistrationDetails();

  }

  alreadySubmitted: boolean = false;

  // ============================================================
  // LOAD ORDER DETAILS
  // ============================================================

  private loadRegistrationDetails(): void {

    this.isLoading = true;
    this.loadError = '';
    this.alreadySubmitted = false;

    this.shortCourseService
      .getPaidRegistrationById(this.orderId)
      .subscribe({

        next: (response: any) => {

          this.isLoading = false;

          // ====================================================
          // NO RECORD = ALREADY SUBMITTED
          // ====================================================

          if (!response) {
            this.alreadySubmitted = true;
            return;
          }

          this.courseTitle =
            response.shortCourseTitle || '';

          // ====================================================
          // PREFILL INFORMATION FROM ORDER
          // ====================================================

          this.participant.orderId =
            response.id;

          this.participant.courseTitle =
            response.shortCourseTitle || '';

          this.participant.firstName =
            response.studentGivenName || '';

          this.participant.lastName =
            response.studentSingleName || '';

          this.participant.emailAddress =
            response.studentEmail || '';

          // ====================================================
          // LOAD PREVIOUS REGISTRATION IF EXISTS
          // ====================================================

          let savedBody: any = null;

          if (response.registrationBody) {

            try {

              savedBody =
                typeof response.registrationBody === 'string'
                  ? JSON.parse(response.registrationBody)
                  : response.registrationBody;

              Object.assign(
                this.participant,
                savedBody
              );

              // ORDER INFORMATION ALWAYS COMES FROM DB

              this.participant.orderId =
                response.id;

              this.participant.courseTitle =
                response.shortCourseTitle || '';

              this.participant.firstName =
                response.studentGivenName || '';

              this.participant.lastName =
                response.studentSingleName || '';

              this.participant.emailAddress =
                response.studentEmail || '';

              // Restore multiple certificate / ID collections.
              this.normaliseDocumentCollections(
                savedBody
              );

            } catch (error) {

              console.error(
                'Unable to parse registration body:',
                error
              );

            }
          }

          // ====================================================
          // SELECTED TRAINING
          // ====================================================

          this.loadSelectedTrainingCourses(
            response,
            savedBody
          );

          // ====================================================
          // PREFILL APPLICANT NAME
          // ====================================================

          if (!this.participant.applicantName) {

            this.participant.applicantName =
              `${this.participant.firstName} ${this.participant.lastName}`.trim();

          }
        },

        error: (error) => {

          console.error(
            'Registration load failed:',
            error
          );

          this.isLoading = false;

          // ====================================================
          // 404 = RECORD NOT AVAILABLE / ALREADY SUBMITTED
          // ====================================================

          if (error.status === 404) {

            this.alreadySubmitted = true;
            return;

          }

          // ====================================================
          // ACTUAL ERROR
          // ====================================================

          this.loadError =
            'Unable to load registration details. Please try again later.';
        }

      });
  }

  // ============================================================
  // SELECTED TRAINING
  // ============================================================

  private loadSelectedTrainingCourses(
    response: any,
    savedBody: any = null
  ): void {

    const selectedCourses:
      SelectedTrainingCourse[] = [];


    const addCourse = (
      type: string,
      code: any,
      name: any
    ): void => {

      const normalisedType =
        this.normaliseTrainingType(
          type
        );

      const normalisedCode =
        String(
          code ?? ''
        ).trim();

      const normalisedName =
        String(
          name ?? ''
        ).trim();


      if (
        !normalisedCode &&
        !normalisedName
      ) {
        return;
      }


      const duplicate =
        selectedCourses.some(
          course =>
            course.type === normalisedType &&
            course.code.toUpperCase() ===
            normalisedCode.toUpperCase() &&
            course.name.toUpperCase() ===
            normalisedName.toUpperCase()
        );


      if (duplicate) {
        return;
      }


      selectedCourses.push({
        type:
          normalisedType,
        code:
          normalisedCode,
        name:
          normalisedName
      });
    };


    const parseObject =
      (value: any): any => {

        if (!value) {
          return null;
        }


        if (
          typeof value ===
          'object'
        ) {
          return value;
        }


        if (
          typeof value !==
          'string'
        ) {
          return null;
        }


        try {

          return JSON.parse(
            value
          );

        } catch {

          return null;
        }
      };


    /*
     * Read from the API response first.
     *
     * The helper also accepts common nested body structures so it will
     * work if the backend returns selected courses from an order/enquiry
     * JSON body instead of directly on the response model.
     */
    const possibleBodies =
      [
        response,
        savedBody,
        parseObject(
          response?.body
        ),
        parseObject(
          response?.bookingBody
        ),
        parseObject(
          response?.orderBody
        ),
        parseObject(
          response?.enquiryBody
        )
      ]
        .filter(
          body =>
            !!body
        );


    const containers: any[] =
      [];


    possibleBodies.forEach(
      body => {

        containers.push(
          body
        );


        if (
          body?.participant &&
          typeof body.participant ===
          'object'
        ) {

          containers.push(
            body.participant
          );
        }


        if (
          Array.isArray(
            body?.participants
          )
        ) {

          body.participants
            .forEach(
              (participant: any) =>
                containers.push(
                  participant
                )
            );
        }
      }
    );


    containers.forEach(
      container => {

        // --------------------------------------------------------
        // UOC
        // --------------------------------------------------------

        const uocLists =
          [
            container?.uocCourses,
            container?.UOCCourses,
            container?.selectedUOCCourses,
            container?.selectedUocCourses
          ];


        uocLists.forEach(
          list => {

            if (
              !Array.isArray(list)
            ) {
              return;
            }


            list.forEach(
              (course: any) => {

                addCourse(
                  'UOC',
                  course?.courseCode
                  ?? course?.CourseCode
                  ?? course?.code
                  ?? course?.Code,
                  course?.courseTitle
                  ?? course?.CourseTitle
                  ?? course?.courseName
                  ?? course?.CourseName
                  ?? course?.name
                  ?? course?.Name
                );
              }
            );
          }
        );


        // --------------------------------------------------------
        // VOC
        // --------------------------------------------------------

        const vocLists =
          [
            container?.vocCourses,
            container?.VOCCourses,
            container?.selectedVOCCourses,
            container?.selectedVocCourses
          ];


        vocLists.forEach(
          list => {

            if (
              !Array.isArray(list)
            ) {
              return;
            }


            list.forEach(
              (voc: any) => {

                addCourse(
                  'VOC',
                  voc?.vocCode
                  ?? voc?.VOCCode
                  ?? voc?.courseCode
                  ?? voc?.CourseCode
                  ?? voc?.code
                  ?? voc?.Code,
                  voc?.vocName
                  ?? voc?.VOCName
                  ?? voc?.courseTitle
                  ?? voc?.CourseTitle
                  ?? voc?.courseName
                  ?? voc?.CourseName
                  ?? voc?.name
                  ?? voc?.Name
                );
              }
            );
          }
        );


        // --------------------------------------------------------
        // COA
        // --------------------------------------------------------

        const coaLists =
          [
            container?.coaCourses,
            container?.COACourses,
            container?.selectedCOACourses,
            container?.selectedCoaCourses
          ];


        coaLists.forEach(
          list => {

            if (
              !Array.isArray(list)
            ) {
              return;
            }


            list.forEach(
              (coa: any) => {

                if (
                  typeof coa ===
                  'string'
                ) {

                  addCourse(
                    'COA',
                    '',
                    coa
                  );

                  return;
                }


                addCourse(
                  'COA',
                  coa?.courseCode
                  ?? coa?.CourseCode
                  ?? coa?.code
                  ?? coa?.Code,
                  coa?.courseName
                  ?? coa?.CourseName
                  ?? coa?.courseTitle
                  ?? coa?.CourseTitle
                  ?? coa?.name
                  ?? coa?.Name
                );
              }
            );
          }
        );


        // --------------------------------------------------------
        // GENERIC SELECTED COURSE LIST
        // --------------------------------------------------------

        const genericLists =
          [
            container?.selectedCourses,
            container?.SelectedCourses,
            container?.courses,
            container?.Courses
          ];


        genericLists.forEach(
          list => {

            if (
              !Array.isArray(list)
            ) {
              return;
            }


            list.forEach(
              (course: any) => {

                const type =
                  course?.courseType
                  ?? course?.CourseType
                  ?? course?.trainingType
                  ?? course?.TrainingType
                  ?? course?.type
                  ?? course?.Type
                  ?? 'COURSE';


                addCourse(
                  type,
                  course?.courseCode
                  ?? course?.CourseCode
                  ?? course?.vocCode
                  ?? course?.VOCCode
                  ?? course?.code
                  ?? course?.Code,
                  course?.courseTitle
                  ?? course?.CourseTitle
                  ?? course?.courseName
                  ?? course?.CourseName
                  ?? course?.vocName
                  ?? course?.VOCName
                  ?? course?.name
                  ?? course?.Name
                );
              }
            );
          }
        );
      }
    );


    /*
     * Direct single-course response support.
     */
    if (
      selectedCourses.length ===
      0
    ) {

      const directCourseName =
        response?.courseTitle
        ?? response?.shortCourseTitle
        ?? response?.courseName
        ?? '';


      const directCourseCode =
        response?.courseCode
        ?? response?.shortCourseCode
        ?? '';


      const directCourseType =
        response?.courseType
        ?? response?.trainingType
        ?? 'COURSE';


      addCourse(
        directCourseType,
        directCourseCode,
        directCourseName
      );
    }


    /*
     * Existing payment flow stores the selected course in session storage.
     * Use it only as a final display fallback and only when its order id
     * matches this registration order.
     */
    if (
      selectedCourses.length ===
      0
    ) {

      try {

        const pendingBookingText =
          sessionStorage.getItem(
            'ecb_pending_booking'
          );


        if (pendingBookingText) {

          const pendingBooking =
            JSON.parse(
              pendingBookingText
            );


          const pendingOrderId =
            Number(
              pendingBooking?.OrderId
              ?? pendingBooking?.orderId
              ?? 0
            );


          if (
            pendingOrderId ===
            Number(this.orderId)
          ) {

            addCourse(
              pendingBooking?.courseType
              ?? 'COURSE',
              pendingBooking?.courseCode
              ?? '',
              pendingBooking?.courseName
              ?? ''
            );
          }
        }

      } catch {

        // Ignore invalid/stale session storage.
      }
    }


    this.selectedTrainingCourses =
      selectedCourses;
  }


  private normaliseTrainingType(
    value: any
  ): 'UOC' | 'VOC' | 'COA' | 'COURSE' {

    const type =
      String(
        value ?? ''
      )
        .trim()
        .toUpperCase();


    if (
      type.includes('VOC')
    ) {
      return 'VOC';
    }


    if (
      type.includes('COA')
    ) {
      return 'COA';
    }


    if (
      type.includes('UOC') ||
      type.includes('UNIT')
    ) {
      return 'UOC';
    }


    return 'COURSE';
  }


  // ============================================================
  // DOCUMENT COLLECTION NORMALISATION
  // ============================================================

  private normaliseDocumentCollections(
    savedBody: any
  ): void {

    const savedCertificates =
      Array.isArray(
        savedBody?.qualificationCertificates
      )
        ? savedBody.qualificationCertificates
        : [];


    if (savedCertificates.length > 0) {

      this.participant.qualificationCertificates =
        savedCertificates
          .map(
            (certificate: any) => ({

              fileName:
                certificate?.fileName ||
                certificate?.certificateFileName ||
                certificate?.name ||
                '',

              fileUrl:
                certificate?.fileUrl ||
                certificate?.certificateFileUrl ||
                certificate?.url ||
                '',

              uploadError: '',

              isUploading: false
            })
          )
          .filter(
            (certificate: any) =>
              !!certificate.fileName ||
              !!certificate.fileUrl
          );
    }
    else if (
      savedBody?.certificateFileName ||
      savedBody?.certificateFileUrl
    ) {

      // Backward compatibility with the old single-certificate JSON.
      this.participant.qualificationCertificates = [
        {
          fileName:
            savedBody?.certificateFileName || '',

          fileUrl:
            savedBody?.certificateFileUrl || '',

          uploadError: '',

          isUploading: false
        }
      ];
    }
    else {

      this.participant.qualificationCertificates = [];
    }


    const savedIdDocuments =
      Array.isArray(
        savedBody?.idDocuments
      )
        ? savedBody.idDocuments
        : [];


    if (savedIdDocuments.length > 0) {

      this.participant.idDocuments =
        savedIdDocuments.map(
          (document: any) => ({

            idType:
              document?.idType || '',

            fileName:
              document?.fileName ||
              document?.idFileName ||
              document?.name ||
              '',

            fileUrl:
              document?.fileUrl ||
              document?.idFileUrl ||
              document?.url ||
              '',

            uploadError: '',

            isUploading: false
          })
        );
    }
    else if (
      savedBody?.idType ||
      savedBody?.idFileName ||
      savedBody?.idFileUrl
    ) {

      // Backward compatibility with the old single-ID JSON.
      this.participant.idDocuments = [
        {
          idType:
            savedBody?.idType || '',

          fileName:
            savedBody?.idFileName || '',

          fileUrl:
            savedBody?.idFileUrl || '',

          uploadError: '',

          isUploading: false
        }
      ];
    }
    else {

      this.participant.idDocuments = [
        this.createEmptyIdDocument()
      ];
    }


    this.participant.certificateUploadError = '';

    this.participant.submittedDate =
      savedBody?.submittedDate ||
      this.participant.submittedDate ||
      new Date().toLocaleDateString('en-CA');
  }


  // ============================================================
  // CREATE EMPTY ID DOCUMENT
  // ============================================================

  private createEmptyIdDocument(): any {

    return {
      idType: '',
      fileName: '',
      fileUrl: '',
      uploadError: '',
      isUploading: false
    };
  }


  // ============================================================
  // VALIDATE UPLOAD FILE
  // ============================================================

  private getUploadValidationError(
    file: File
  ): string {

    const allowedMimeTypes = [
      'application/pdf',
      'image/jpeg',
      'image/png',
      'image/webp'
    ];

    const allowedExtensions = [
      '.pdf',
      '.jpg',
      '.jpeg',
      '.png',
      '.webp'
    ];

    const fileName =
      file.name.toLowerCase();

    const hasValidExtension =
      allowedExtensions.some(
        extension =>
          fileName.endsWith(
            extension
          )
      );

    const hasValidMimeType =
      allowedMimeTypes.includes(
        file.type
      );

    if (
      !hasValidMimeType &&
      !hasValidExtension
    ) {

      return 'Please upload a PDF, JPG, JPEG, PNG or WebP file.';
    }

    const maximumFileSize =
      10 * 1024 * 1024;

    if (
      file.size >
      maximumFileSize
    ) {

      return 'The file must be smaller than 10 MB.';
    }

    return '';
  }


  // ============================================================
  // MULTIPLE CERTIFICATE FILES SELECTED
  // ============================================================

  onCertificateFilesSelected(
    event: Event
  ): void {

    const input =
      event.target as HTMLInputElement;

    const files =
      Array.from(
        input.files || []
      );

    this.participant.certificateUploadError = '';

    if (files.length === 0) {
      return;
    }

    files.forEach(
      file =>
        this.uploadCertificateFile(
          file
        )
    );

    // Allow the same local file to be selected again later if required.
    input.value = '';
  }


  // ============================================================
  // UPLOAD ONE CERTIFICATE
  // ============================================================

  private uploadCertificateFile(
    file: File
  ): void {

    const validationError =
      this.getUploadValidationError(
        file
      );

    if (validationError) {

      this.participant.certificateUploadError =
        validationError;

      return;
    }

    const certificate = {
      fileName: file.name,
      fileUrl: '',
      uploadError: '',
      isUploading: true
    };

    this.participant
      .qualificationCertificates
      .push(
        certificate
      );

    this.uploadService
      .uploadSingleFile(
        file,
        'VOC-form'
      )
      .subscribe({

        next: (response: any) => {

          certificate.isUploading =
            false;

          const uploadedUrl =
            response?.publicUrl || '';

          if (!uploadedUrl) {

            certificate.uploadError =
              'The file was uploaded, but the file URL was not returned.';

            return;
          }

          certificate.fileUrl =
            uploadedUrl;
        },

        error: (error) => {

          console.error(
            'Certificate upload failed:',
            error
          );

          certificate.isUploading =
            false;

          certificate.uploadError =
            'File upload failed. Please try again.';
        }

      });
  }


  // ============================================================
  // REMOVE CERTIFICATE
  // ============================================================

  removeQualificationCertificate(
    certificateIndex: number
  ): void {

    this.participant
      .qualificationCertificates
      .splice(
        certificateIndex,
        1
      );

    this.participant.certificateUploadError = '';
  }


  // ============================================================
  // ADD ANOTHER ID DOCUMENT
  // ============================================================

  addIdDocument(): void {

    this.participant
      .idDocuments
      .push(
        this.createEmptyIdDocument()
      );
  }


  // ============================================================
  // REMOVE ID DOCUMENT
  // ============================================================

  removeIdDocument(
    idIndex: number
  ): void {

    if (
      this.participant.idDocuments.length <= 1
    ) {

      this.participant.idDocuments[0] =
        this.createEmptyIdDocument();

      return;
    }

    this.participant
      .idDocuments
      .splice(
        idIndex,
        1
      );
  }


  // ============================================================
  // ID FILE SELECTED
  // ============================================================

  onIdFileSelected(
    event: Event,
    idIndex: number
  ): void {

    const input =
      event.target as HTMLInputElement;

    const file =
      input.files?.[0];

    const document =
      this.participant
        .idDocuments[
      idIndex
      ];

    if (!document) {
      input.value = '';
      return;
    }

    document.uploadError = '';

    if (!file) {
      return;
    }

    if (!document.idType) {

      document.uploadError =
        'Please select an ID type first.';

      input.value = '';

      return;
    }

    const validationError =
      this.getUploadValidationError(
        file
      );

    if (validationError) {

      document.uploadError =
        validationError;

      input.value = '';

      return;
    }

    document.fileName =
      file.name;

    document.fileUrl =
      '';

    document.isUploading =
      true;

    this.uploadService
      .uploadSingleFile(
        file,
        'VOC-form'
      )
      .subscribe({

        next: (response: any) => {

          document.isUploading =
            false;

          const uploadedUrl =
            response?.publicUrl || '';

          if (!uploadedUrl) {

            document.uploadError =
              'The file was uploaded, but the file URL was not returned.';

            return;
          }

          document.fileUrl =
            uploadedUrl;
        },

        error: (error) => {

          console.error(
            'ID document upload failed:',
            error
          );

          document.isUploading =
            false;

          document.uploadError =
            'File upload failed. Please try again.';

          document.fileUrl = '';
        }

      });

    input.value = '';
  }


  // ============================================================
  // CHECK CERTIFICATE UPLOAD
  // ============================================================

  hasCertificateUploading(): boolean {

    return (
      this.participant
        .qualificationCertificates || []
    ).some(
      (certificate: any) =>
        certificate.isUploading
    );
  }


  // ============================================================
  // CHECK FILE UPLOAD
  // ============================================================

  hasUploadingFiles(): boolean {

    const certificateUploading =
      this.hasCertificateUploading();

    const idUploading =
      (
        this.participant
          .idDocuments || []
      ).some(
        (document: any) =>
          document.isUploading
      );

    return (
      certificateUploading ||
      idUploading
    );
  }


  // ============================================================
  // SUBMIT
  // ============================================================

  submitRegistration(): void {

    if (
      this.hasUploadingFiles()
    ) {
      return;
    }

    if (
      !this.participant
        .lastName
        ?.trim()
    ) {

      this.submitError =
        'Last Name is required.';

      return;
    }

    this.isSubmitting =
      true;

    this.submitError =
      '';

    this.submitSuccess =
      false;


    // Save uploaded certificate / ID documents in the same registration JSON body.
    // Temporary UI-only upload flags and error messages are intentionally excluded.
    const registrationBody: any = {

      ...this.participant,

      submittedDate:
        this.participant.submittedDate ||
        new Date().toLocaleDateString('en-CA'),

      qualificationCertificates:
        (
          this.participant
            .qualificationCertificates || []
        )
          .filter(
            (certificate: any) =>
              !!certificate.fileName ||
              !!certificate.fileUrl
          )
          .map(
            (certificate: any) => ({
              fileName:
                certificate.fileName || '',
              fileUrl:
                certificate.fileUrl || ''
            })
          ),

      idDocuments:
        (
          this.participant
            .idDocuments || []
        )
          .filter(
            (document: any) =>
              !!document.idType ||
              !!document.fileName ||
              !!document.fileUrl
          )
          .map(
            (document: any) => ({
              idType:
                document.idType || '',
              fileName:
                document.fileName || '',
              fileUrl:
                document.fileUrl || ''
            })
          )
    };


    // Remove temporary UI-only values.
    delete registrationBody
      .certificateUploadError;


    // Remove old single-file fields if an older saved body contained them.
    delete registrationBody
      .certificateAvailable;

    delete registrationBody
      .certificateFileName;

    delete registrationBody
      .certificateFileUrl;

    delete registrationBody
      .isCertificateUploading;

    delete registrationBody
      .idType;

    delete registrationBody
      .idNumber;

    delete registrationBody
      .idExpiryDate;

    delete registrationBody
      .idFileName;

    delete registrationBody
      .idFileUrl;

    delete registrationBody
      .idUploadError;

    delete registrationBody
      .isIdUploading;


    this.shortCourseService
      .savePaidRegistration(
        this.orderId,
        registrationBody
      )
      .subscribe({

        next: () => {

          this.isSubmitting =
            false;

          this.submitSuccess =
            true;

          setTimeout(
            () => {
              this.router.navigate(['/']);
            },
            500
          );
        },

        error: (error) => {

          console.error(
            'Registration submission failed:',
            error
          );

          this.isSubmitting =
            false;

          this.submitError =
            'Unable to submit registration. Please try again.';
        }

      });
  }

}
